<div id="skipnav">
  <p class="skipnav"><a (click)="onClick($event, 'mainContent')" href="#mainContent">Skip to Content</a></p>
</div>
<div [ngClass]="{'bg-dark':routerOutlet.activatedRouteData.bgDark}">
  <div class="container-main p-0 relative-md"
    [ngClass]="{'container-fluid': routerOutlet.activatedRouteData.fluidContainer, 'container-xl': !routerOutlet.activatedRouteData.fluidContainer, 'container-getting-started':routerOutlet.activatedRouteData.gettingStarted || userData?.expired}"
    (window:resize)="onResize($event)" #mainContainer>

    <div class="sidebar-container"
      [ngClass]="{'sidebar-container-on':!routerOutlet.activatedRouteData.hideSiebar, 'sidebar-container-off':routerOutlet.activatedRouteData.hideSiebar }">

      <app-sidebar *ngIf="!routerOutlet.activatedRouteData.hideSiebar && !userData?.expired"
        [section]="routerOutlet.activatedRouteData.pageTitle"></app-sidebar>
    </div>
    <div [ngClass]="{'has-sidebar': !routerOutlet.activatedRouteData.hideSiebar && !userData?.expired}">

      <app-navbar [pageTitle]="routerOutlet.activatedRouteData.pageTitle"
        [pageIcon]="routerOutlet.activatedRouteData.pageIcon"
        [navbarOptions]="routerOutlet.activatedRouteData.navbarOptions"
        [tallNav]="routerOutlet.activatedRouteData.hideSiebar" [home]="routerOutlet.activatedRouteData.home"
        [resourceId]="routerOutlet.activatedRouteData.resourceId" [routerOutlet]="routerOutlet"
        *ngIf="!routerOutlet.activatedRouteData.hideTopNav"></app-navbar>
      <div class="animation-container relative" role="main" id="mainContent">
        <div class="content-wrap" [@routeAnimations]="showMobile(routerOutlet)"
          [@routeAnimationsDesktop]="showDesktop(routerOutlet)">
          <router-outlet #routerOutlet="outlet"></router-outlet>
          <app-footer *ngIf="!routerOutlet.activatedRouteData.hideFooterNav"
            [hasSidebar]="!routerOutlet.activatedRouteData.hideSiebar"></app-footer>
        </div>
      </div>
    </div>
    <app-footer-nav *ngIf="!routerOutlet.activatedRouteData.hideFooterNav&& !userData?.expired"></app-footer-nav>
    <app-add-to-homescreen></app-add-to-homescreen>
  </div>


</div>
<app-achievement-notification [notifications]="notifications" *ngIf="showAward"
  (closeAward)="onCloseAward($event)"></app-achievement-notification>